import React, { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AES, enc } from "crypto-js";
import { otpVerification } from "../../../../src/services/emailRegister/emailRegisterServices.js";
import "../../../../src/pages/home/home.css";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { getBrandLogo, getBrandLogoAlt } from "../../../utils/brandLogo";
const OtpVerification = () => {
        const { email } = useParams();
        const [otpDig1, setOtpDig1] = useState("");
        const [otpDig2, setOtpDig2] = useState("");
        const [otpDig3, setOtpDig3] = useState("");
        const [otpDig4, setOtpDig4] = useState("");
        const navigate = useNavigate();
        const [loading, setLoading] = useState(false);
        const [hasError, setHasError] = useState(false);

        const otpRef1 = useRef(null);
        const otpRef2 = useRef(null);
        const otpRef3 = useRef(null);
        const otpRef4 = useRef(null);

        const decodedEmail = decodeURIComponent(email.replace(/%2F/g, "/"));
        const decryptedBytes = AES.decrypt(decodedEmail, "encryptionKey");
        const deEmail = decryptedBytes.toString(enc.Utf8);

        const handlePaste = (e) => {
                e.preventDefault();
                const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 4);
                if (!pasted) return;
                if (hasError) setHasError(false);
                const digits = pasted.split("");
                const setters = [setOtpDig1, setOtpDig2, setOtpDig3, setOtpDig4];
                const refs = [otpRef1, otpRef2, otpRef3, otpRef4];
                digits.forEach((d, i) => setters[i](d));
                const focusIndex = Math.min(digits.length, 3);
                refs[focusIndex].current.focus();
        };

        const handleOtpChange = (setOtp, nextRef, prevRef, e) => {
                const value = e.target.value;
                if (hasError) setHasError(false);
                // Only allow single digit (0-9)
                if (value.length === 1 && /^\d$/.test(value)) {
                        setOtp(value);
                        if (nextRef) nextRef.current.focus();
                } else if (
                        value === "" &&
                        prevRef &&
                        e.nativeEvent.inputType === "deleteContentBackward"
                ) {
                        prevRef.current.focus();
                        setOtp("");
                }
        };

        const validateOtp = async () => {
                setHasError(false);
                // Validate all fields are filled
                if (!otpDig1 || !otpDig2 || !otpDig3 || !otpDig4) {
                        setHasError(true);
                        toast.error("Please enter all 4 digits", {
                                position: "bottom-right",
                                autoClose: 2000,
                        });
                        return;
                }

                setLoading(true);
                try {
                        const otp = parseInt(otpDig1 + otpDig2 + otpDig3 + otpDig4);
                        // Validate OTP is a valid number
                        if (isNaN(otp) || otp < 1000 || otp > 9999) {
                                setHasError(true);
                                setLoading(false);
                                toast.error("Please enter a valid 4-digit OTP", {
                                        position: "bottom-right",
                                        autoClose: 2000,
                                });
                                return;
                        }

                        const result = await otpVerification(deEmail, otp);
                        
                        if (result === true) {
                                // Don't set loading to false if navigating
                                navigate(
                                        `/app/register/${encodeURIComponent(
                                                AES.encrypt(deEmail, "encryptionKey")
                                                        .toString()
                                                        .replace(/\//g, "%2F")
                                        )}/${otp}`
                                );
                        } else {
                                setHasError(true);
                                setLoading(false);
                                toast.error("OTP is incorrect. Please try again.", {
                                        position: "bottom-right",
                                        autoClose: 2000,
                                });
                        }
                } catch (error) {
                        setHasError(true);
                        setLoading(false);
                        console.error('OTP verification error:', error);
                        toast.error(error.response?.data?.message || "An error occurred. Please try again.", {
                                position: "bottom-right",
                                autoClose: 2000,
                        });
                }
        };

        const handleBackspace = (e, currentRef, prevRef, setOtp) => {
                if (e.key === "Backspace") {
                        // Clear error state when user starts editing
                        if (hasError) {
                                setHasError(false);
                        }
                        // If current field is empty and has previous field, focus previous
                        if (e.target.value === "" && prevRef) {
                                prevRef.current.focus();
                        } else {
                                setOtp("");
                        }
                }
        };

        return (
                <>
                        <div className="otp-outer-bg">
                                <div className="top-logo">
                                <a href="/"><img src={getBrandLogo()} alt={getBrandLogoAlt()} /></a>
                                </div>
                                <div className="top-logo-mobile">
                                <a href="/"><img src={getBrandLogo()} alt={getBrandLogoAlt()} /></a>
                                </div>
                                <div className="otp-section-outer">

                                        <div className="outer-otp">
                                                <div className="enter-otp-head">Check your email</div>
                                                <div className="enter-otp-subhead">
                                                        We sent a 4-digit verification code to<br />
                                                        <strong>{deEmail}</strong>
                                                </div>
                                                <div className="enter-otp-hint">
                                                        Enter the code below to verify your email address. Check your spam folder if you don't see it.
                                                </div>
                                                <div className="otp-section-inner">
                                                        <input
                                                                type="text"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                value={otpDig1}
                                                                ref={otpRef1}
                                                                className={hasError ? 'otp-input-error' : ''}
                                                                onChange={(e) => handleOtpChange(setOtpDig1, otpRef2, null, e)}
                                                                onKeyDown={(e) => handleBackspace(e, otpRef1, null, setOtpDig1)}
                                                                onPaste={handlePaste}
                                                                maxLength={1}
                                                                disabled={loading}
                                                        />
                                                        <input
                                                                type="text"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                value={otpDig2}
                                                                ref={otpRef2}
                                                                className={hasError ? 'otp-input-error' : ''}
                                                                onChange={(e) => handleOtpChange(setOtpDig2, otpRef3, otpRef1, e)}
                                                                onKeyDown={(e) => handleBackspace(e, otpRef2, otpRef1, setOtpDig2)}
                                                                onPaste={handlePaste}
                                                                maxLength={1}
                                                                disabled={loading}
                                                        />
                                                        <input
                                                                type="text"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                value={otpDig3}
                                                                ref={otpRef3}
                                                                className={hasError ? 'otp-input-error' : ''}
                                                                onChange={(e) => handleOtpChange(setOtpDig3, otpRef4, otpRef2, e)}
                                                                onKeyDown={(e) => handleBackspace(e, otpRef3, otpRef2, setOtpDig3)}
                                                                onPaste={handlePaste}
                                                                maxLength={1}
                                                                disabled={loading}
                                                        />
                                                        <input
                                                                type="text"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                value={otpDig4}
                                                                ref={otpRef4}
                                                                className={hasError ? 'otp-input-error' : ''}
                                                                onChange={(e) => handleOtpChange(setOtpDig4, null, otpRef3, e)}
                                                                onKeyDown={(e) => handleBackspace(e, otpRef4, otpRef3, setOtpDig4)}
                                                                onPaste={handlePaste}
                                                                maxLength={1}
                                                                disabled={loading}
                                                        />
                                                </div>
                                                <div className="opt-verify-button">
                                                        <button onClick={validateOtp} disabled={loading}>
                                                                {loading ? (
                                                                        <div className="outter-load-table">
                                                                                <ThreeDots
                                                                                        height="20"
                                                                                        width="40"
                                                                                        radius="4"
                                                                                        color="white"
                                                                                        ariaLabel="three-dots-loading"
                                                                                        wrapperStyle={{}}
                                                                                        wrapperClassName=""
                                                                                        visible={true}
                                                                                />
                                                                        </div>
                                                                ) : (
                                                                        "Verify"
                                                                )}
                                                        </button>
                                                </div>
                                        </div>
                                </div>
                        </div>
                </>
        );
};

export default OtpVerification;